import { ICellRendererParams } from "ag-grid-community";
import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { useRouteContext } from "../../../hooks/use-route-context/UseRouteContext";
import { format } from "date-fns";
import { routes } from "../../../routes/routes";
import { UIViewEnum } from "../../../common/enums/UIViewEnum";
import { getDeviceRoute, getWellRoute } from "../../../common/utilities/RouteHelpers";
import storageService from "../../../services/storage/storage-service/StorageService";
import useNavigateTo, { NavigateToOptions } from "../../../hooks/use-navigate-to/useNavigateTo";
import { NewViewTypeEnum } from "../../../common/enums/NewViewTypeEnum";


export function MemoCellRendererV2({
    value,
    data,
}: ICellRendererParams) {
    const routeContext = useRouteContext();
    const navigateTo = useNavigateTo();

    const onMemoClicked = (shiftKey: boolean, ctrlKey: boolean) => {

        let options: NavigateToOptions | undefined;

        if (shiftKey || ctrlKey) {
            options = {
                newViewType: shiftKey ? NewViewTypeEnum.NewWindow : NewViewTypeEnum.NewTab
            }
        }


        const viewID = data?.wellID ?
            UIViewEnum.Well_Details_History :
            UIViewEnum.Device_Details_History;

        const item = routes.find(o => o.viewID === viewID);

        let url: string | undefined;

        if (data?.deviceID) {

            url = getDeviceRoute(item?.viewID as UIViewEnum,
                routeContext.groupID,
                routeContext.wellID,
                data.deviceID);
        } else if (data?.wellID) {
            url = getWellRoute(item?.viewID as UIViewEnum,
                routeContext.groupID,
                data.wellID);
        }

        if (url) {
            // allow the view to scroll to memo
            storageService.session.set("memoID", data?.memoID);
            navigateTo(url, options);
        }
    }

    const tooltip = value
        ? <Stack direction="column" 
                sx={{
                    cursor: 'pointer'
                }} 
                onClick={(ev) => onMemoClicked(ev.shiftKey, ev.ctrlKey)}
            >
                <Typography variant="caption">{data?.memoText}</Typography>
                <Typography variant="caption">{data?.memoCreatedBy}</Typography>
                <Typography variant="caption">{data?.memoTimestamp ? format(new Date(data?.memoTimestamp), "P pp") : ''}</Typography>
            </Stack>
        : ""

    return (data?.memoText
        ? 
        <Box sx={{overflow: 'hidden'}}>
            <Tooltip 
                title={tooltip} 
                placement='bottom-end' 
                //sx={{overflow: 'hidden'}}
            >
                <Box sx={{
                    display: "flex",
                    //flexDirection: "column",
                    //flexGrow: 1,
                    overflow: 'hidden',
                    
                }}>
                    <Box 
                        sx={{
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis', 
                            cursor: 'pointer'
                        }} 
                        onClick={(ev) => {
                            onMemoClicked(ev.shiftKey, ev.ctrlKey);
                        }}
                    >
                        {data?.memoText}
                    </Box>
                </Box>
            </Tooltip>
        </Box>
        : undefined
    )
}

